import React from 'react'
import Modal from 'view/component/generic/modal'
import * as ACTIONS from 'constant/actions/navigation'
import * as VERSION_ACTIONS from 'constant/actions/version-management'
import initialState from './initial-state'

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.NAVIGATION_SHOW_MODAL:
      state = {
        ...state,
        modalContent: action.modalContent,
        modalShowing: true
      }
      break
    case ACTIONS.NAVIGATION_HIDE_MODAL:
      state = {
        ...state,
        modalContent: undefined,
        modalShowing: false
      }
      break
    case VERSION_ACTIONS.VERSION_MANAGEMENT_CREATE_NEW_VERSION + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          modalShowing: true,
          modalContent: <Modal message='Your new version has been created successfully' messageTitle='Version Creation' />
        }
      } else {
        state = {
          ...state,
          modalShowing: true,
          modalContent: <Modal message={action.payload.data.message} messageTitle='Version Creation' />
        }
      }
      break
  }
  return state
}
